<template>
  <a-tag :color="color" :style="{ textTransform: 'uppercase' }">
    {{ props.stateTag }}
  </a-tag>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  stateId: {
    type: Number,
    required: true
  },
  stateTag: {
    type: String,
    required: true
  }
});

const colorMap = {
  1: 'processing',
  2: 'error',
  3: 'success',
  4: 'success'
};

const color = computed(() => colorMap[props.stateId] || 'processing');
</script>
